import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { JwtService } from './jwt.service';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SxSecurityService } from './sxSecurity.service';
import { ReplaySubject } from 'rxjs';
import { CacheService } from './cache.service';

export interface CurrentUser {
  name: string;
};

@Injectable()
export class AuthService {
  url = 'api/Authentication';

  private currentUserSubject = new ReplaySubject<CurrentUser>(1);
  currentUser = this.currentUserSubject.asObservable().distinctUntilChanged();

  constructor(private sxHttp: SxHttpService,
              private security: SxSecurityService,
              private cacheService: CacheService) {
    // refrescamos el usuario por cada vez que la autenticacion cambia
    this.security.isAuthenticated
    .filter(estaAutenticado => estaAutenticado)
    .subscribe(_ => this.refreshCurrentUser());
  }

  refreshCurrentUser() {
    this.sxHttp.get('api/Authentication/CurrentUser')
      .toPromise()
      .then(result => {
        const user = {
          name: result.json().data,
        };
        this.cacheService.setCurrentUser(user);
        this.currentUserSubject.next(user);
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/auth.service.ts